export const getCurrencyCode = (member) => {
  return "AED";
};

export const getFullName = (member) => {
  let fullName = "";

  if (member && member?.firstName) {
    fullName = member?.title ? member?.title : "";
    fullName += fullName ? " " + member?.firstName : member?.firstName;
    fullName += fullName ? " " + member?.lastName : member?.lastName;
  }

  return fullName;
};
export function getAllNumbersBetween(x, y) {
  var numbers = [];
  // Set a temporary variable i to start at value x.
  // As long as the value of i is less than the value y, increment it.
  // The loop will end when i is equal to y.
  for (var i = x; i >= y; i--) {
    numbers.push(i);
  }
  return numbers;
}
export const handleFormatArray = (item) => {
  const array = [];
  for (let i = 0; i < item.length; i++) {
    array.push({ label: item[i], value: item[i] });
  }

  return array;
};
export const isTrue = (value) => {
  if (value === 1 || value === "1" || value === true || value === "true")
    return true;
  return false;
};

export const isEmpty = (data) => {
  if (
    data === undefined ||
    data === "undefined" ||
    data === null ||
    data === "null" ||
    data === ""
  )
    return true;
  return false;
};

export const isValidEmail = (email) => {
  if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email)) {
    return true;
  }
  return false;
};

export function upperCaseFirst(str) {
  if (!str) return "";

  const arr = str.split(" ");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  return arr.join(" ");
}

export const getDayName = (dateString) => {
  // Convert "03 November 2025" into a Date object
  const date = new Date(dateString);

  // Get weekday name
  const options = { weekday: "long" }; // full day name (e.g., Monday)
  return date.toLocaleDateString("en-US", options);
};

export const getFoodTimeOptions = (foods) => {
  if (!Array.isArray(foods)) return [];

  const uniqueFoodTimes = [...new Set(foods.map((food) => food.foodTime))];

  return uniqueFoodTimes.map((time) => ({
    label: time,
    value: time,
  }));
};

export const isDatePassed = (dateString) => {
  // Convert dateString (like "03 November 2025") to Date object
  const inputDate = new Date(dateString);
  const today = new Date();

  // Set both to midnight for accurate date comparison
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  // Return true if inputDate is before today
  return inputDate < today;
};

export const getUniqueYearOptions = (items) => {
  if (!Array.isArray(items)) return [];

  const uniqueYears = [...new Set(items.map((item) => item.yearForFilter))];

  return uniqueYears.map((year) => ({
    label: year,
    value: year,
  }));
};

// Check if given date is today
export const isToday = (dateString) => {
  const inputDate = new Date(dateString);
  const today = new Date();

  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return inputDate.getTime() === today.getTime();
};

// Check if given date is tomorrow
export const isTomorrow = (dateString) => {
  const inputDate = new Date(dateString);
  const today = new Date();

  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  return inputDate.getTime() === tomorrow.getTime();
};

export const getLookupOptionsByName = (lookups, name) => {
  if (!Array.isArray(lookups)) return [];

  const lookup = lookups.find(
    (item) => item.name?.toLowerCase() === name.toLowerCase()
  );

  if (!lookup || !Array.isArray(lookup.items)) return [];

  return lookup.items.map((i) => ({
    label: i.value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()), // e.g. "water_bottle" → "Water Bottle"
    value: i.value,
  }));
};

export const getMealIdByFoodTime = (data, foodTime) => {
  if (!data) return null;

  // Handle both data.meals and data (if it's already an array)
  const meals = Array.isArray(data) ? data : data.meals;

  if (!Array.isArray(meals) || meals.length === 0) return null;

  const target = foodTime?.trim().toLowerCase();
  if (!target) return null;

  // normalize snack variations and similar terms
  const normalize = (str) =>
    str
      ?.toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/snacks?/g, "snack")
      .trim();

  const normalizedTarget = normalize(target);

  // fuzzy match
  const meal = meals.find((m) => {
    const mealTitle = normalize(m.title);
    return (
      mealTitle === normalizedTarget ||
      mealTitle.includes(normalizedTarget) ||
      normalizedTarget.includes(mealTitle)
    );
  });

  return meal ? meal._id : null;
};
export const getFoodTimeByMealId = (data, mealId) => {
  if (!data || !mealId) return null;

  // Accept both data.meals or direct array
  const meals = Array.isArray(data) ? data : data.meals;

  if (!Array.isArray(meals) || meals.length === 0) return null;

  const match = meals.find((m) => m?._id?.toString() === mealId?.toString());

  return match ? match.title : null; // return the meal title (food time)
};

export const calculateDefaultMealsCount = (data, statsId) => {
  // Find the meal title corresponding to the statsId
  const meal = data.stats.find((item) => item._id === statsId);
  if (!meal) return null; // If statsId not found

  const mealTitle = meal.title;
  const totalSubs = meal.totalSubscriptions;

  // Get all menu items for that meal
  const menuItems = data.menuItems[mealTitle] || [];

  // Sum selectedByCustomers for all items
  const totalSelected = menuItems.reduce(
    (sum, item) => sum + item.selectedByCustomers,
    0
  );

  // Return remaining subscriptions
  return totalSubs - totalSelected;
};

export const isSuperAdmin = () => {};


export const getPausedDates = (startDate, endDate) => {
  const start = parseLongDate(startDate);
  const end = parseLongDate(endDate);

  if (!start || !end) return [];

  // Normalize both to midnight to avoid timezone shifting issues
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  // Create safe copies before adding days
  const pauseStart = new Date(start);
  pauseStart.setDate(pauseStart.getDate() + 2); // +48h

  const pauseEnd = new Date(end);
  pauseEnd.setDate(pauseEnd.getDate() + 1); // +1 day

  const dates = [];
  const current = new Date(pauseStart);

  while (current <= pauseEnd) {
    const day = current.getDay(); // 0 = Sun, 6 = Sat

    if (day !== 0 && day !== 6) {
      // Push only the formatted date
      dates.push(formatLongDate(current));
    }

    current.setDate(current.getDate() + 1);
  }

  return dates;
};


// parse "08 December 2025"
export const parseLongDate = (str) => {
  if (!str) return null;

  // ISO date “2025-11-30T00:00:00.000Z”
  if (typeof str === "string" && str.includes("T")) {
    return new Date(str);
  }

  // “10 December 2025”
  if (typeof str === "string") {
    const [day, monthName, year] = str.split(" ");
    const month = new Date(`${monthName} 1, 2000`).getMonth();
    return new Date(year, month, parseInt(day));
  }

  return null;
};

// convert Date object to "10 December 2025"
export const formatLongDate = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

// check if formatted date exists in the array
export const includesLongDate = (dateArray, longDateStr) => {
  const [day, monthName, year] = longDateStr.split(" ");
  const month = new Date(`${monthName} 1, 2000`).getMonth();

  return dateArray.some((d) => {
    const date = parseLongDate(d);
    return (
      date.getDate() === parseInt(day) &&
      date.getMonth() === month &&
      date.getFullYear() === parseInt(year)
    );
  });
};
